export default "__VITE_ASSET__a468787b__"